<div class="sync-status-container">
    <!-- Botão Principal de Sincronização -->
    <button
        (click)="handleSyncClick()"
        [disabled]="isButtonDisabled()"
        class="sync-button"
        [class.offline]="isOffline()"
        [class.syncing]="isSyncing()"
        [class.online]="!isOffline() && !isSyncing()"
    >
        <!-- Seção Esquerda - Texto Descritivo -->
        <div class="button-left-section">
            <span class="sync-data-text">Sincronizar dados</span>
        </div>

        <!-- Seção Direita - Ação Principal -->
        <div class="button-right-section">
            <span class="sync-now-text">{{ getButtonText() }}</span>

            <!-- Ícone de Refresh -->
            <div class="refresh-icon" [class.spinning]="isSyncing()">
                <svg class="refresh-svg" viewBox="0 0 24 24" fill="currentColor">
                    <path
                        d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
                    />
                </svg>
            </div>
        </div>
    </button>

    <!-- Status da Última Sincronização -->
    <div class="last-sync-status">
        <span class="last-sync-text ">{{ getLastSyncText() }}</span>
    </div>

    <!-- Informações Adicionais (apenas em desenvolvimento) -->
    <div *ngIf="environment.pwa.devMode" class="debug-info">
        <div class="debug-item">
            <span class="debug-label">Ações pendentes:</span>
            <span class="debug-value">{{ pendingActionsCount() }}</span>
        </div>
        <div class="debug-item">
            <span class="debug-label">Progresso:</span>
            <span class="debug-value">{{ syncProgress() | number: '1.0-0' }}%</span>
        </div>
        <div class="debug-item">
            <span class="debug-label">Fila:</span>
            <span class="debug-value">{{ queueSize() }}</span>
        </div>
    </div>
</div>
